import React, { ReactElement } from 'react';
import useSupplementedTaskPreviewAssignment from 'react-scale/hooks/useSupplementedTaskPreviewAssignment';
import { CorpPreviewAssignmentJson } from '@scale/shared/assignmentJson/types/CorpPreviewAssignmentJson';

interface SupplementedTaskPreviewAssignmentWrapperProps {
  assignment: CorpPreviewAssignmentJson | undefined;
  /**
   * This render should take an updated version of the TaskProps for the component
   */
  render: (assignment: CorpPreviewAssignmentJson | undefined) => ReactElement;
}

/**
 * A wrapper for TaskComponent to allow for hooks to be used on TaskPreview.js
 */
export const SupplementedTaskPreviewAssignmentWrapper: React.FC<
  SupplementedTaskPreviewAssignmentWrapperProps
> = props => {
  const { assignment, render } = props;

  const supplementedTaskPreviewAssignmentJson = useSupplementedTaskPreviewAssignment(assignment);

  return render(supplementedTaskPreviewAssignmentJson);
};
